import {
  JOURNEY_EXIT_EVENT,
  type EventDetailType
} from '@epilot/journey-logic-commons'

import { Button, Typography, Icon } from '../../components'

import classes from './ConfirmationControl.module.scss'

export type ConfirmationMessageComponentProps = {
  title?: string
  text?: string
  closeButtonText?: string
  showCloseButton?: boolean
  id: string
}

export function ConfirmationControl({
  title = '',
  text = '',
  closeButtonText = 'schließen',
  showCloseButton = true,
  id
}: ConfirmationMessageComponentProps) {
  const handleOnExitButton = () => {
    const event = new CustomEvent<EventDetailType>(JOURNEY_EXIT_EVENT, {
      detail: {
        payload: { isCleanJourneyData: true }
      }
    })

    document.dispatchEvent(event)
  }

  return (
    <div className={classes.container}>
      <Icon
        className={classes.icon}
        color="primary"
        isFilled={true}
        name="check_circle"
      />
      <Typography as="h1" className={classes.title} variant="primary">
        {title}
      </Typography>
      <Typography variant="secondary">{text}</Typography>
      {showCloseButton && (
        <Button
          id={id}
          label={closeButtonText}
          onClick={handleOnExitButton}
          variant="primary"
        />
      )}
    </div>
  )
}
